export default {
  ...window.epAppData,
};
